import ThermostatIcon from '@mui/icons-material/Thermostat';

import { TemperatureDatum, useTemperatureData } from '@/api/historicalData';
import { Line } from '@/charts';
import { colorsets } from '@/charts/common';
import { SensorLineChartSection } from '@/components/spotter/historicalDataTab/SensorLineChartSection';
import { useDateRangeContext } from '@/context/DateRangeContext';
import { useSpotterContext } from '@/context/SpotterContext';

export const SUBSURFACE_TEMPERATURE_LINE: Line<TemperatureDatum> = {
    id: 'subsurface-temperature',
    label: 'Water temperature',
    valueKey: 'temperature',
    unitKey: 'units',
    unitTypeKey: 'unitType',
    color: colorsets.blue, // placeholder for type; will be replaced per sensor
};

export const SubsurfaceTemperatureSection = () => {
    const { spotterId } = useSpotterContext();
    const { dateRange } = useDateRangeContext();

    const sensorData = useTemperatureData({
        spotterId: spotterId!,
        dateRange,
    });

    return (
        <SensorLineChartSection
            chartId="subsurface-temperature"
            chartTitle="Subsurface water temperature"
            yAxisLabel="Water temperature"
            sensorType="waterTemperature"
            sensorData={sensorData}
            baseLine={SUBSURFACE_TEMPERATURE_LINE}
            sensorIcon={{
                Icon: ThermostatIcon,
            }}
            alertLineId="smartmooring_threshold_temperature"
        />
    );
};
